import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavDaa from "../components/landing/NavDaa";
import FooterDaa from "../components/landing/FooterDaa";
import CursorSpotlight from "../components/landing/CursorSpotlight";
import "../styles/daa.css";
import "../styles/daa-pages.css";

function MarketingPageFallback() {
  return <div className="page-fallback" aria-busy="true" aria-label="Loading page" />;
}

export default function MarketingLayout() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const timer = window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 100);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return (
    <div className="daa" id="top">
      <a href="#main" className="skip-link">
        Skip to content
      </a>

      <div className="field" aria-hidden="true" />
      <div className="grid-lines" aria-hidden="true" />
      <div className="grain" aria-hidden="true" />
      <CursorSpotlight />

      <NavDaa />
      <main id="main">
        <Suspense fallback={<MarketingPageFallback />}>
          <Outlet />
        </Suspense>
      </main>
      <FooterDaa />
    </div>
  );
}
